import { useTokenPermissionsStore } from "../stores/useTokenPermissionsStore";
import {
  getTokenViewPermission,
  getTokenEditPermission,
  getTokenPermissionsForModule,
  type TokenPermissionModuleType,
} from "../constants/permissions";

export function useTokenPermissions() {
  const store = useTokenPermissionsStore();

  const canView = (module: TokenPermissionModuleType): boolean => {
    return store.hasPermission(getTokenViewPermission(module));
  };

  const canEdit = (module: TokenPermissionModuleType): boolean => {
    return store.hasPermission(getTokenEditPermission(module));
  };

  const canAccess = (module: TokenPermissionModuleType): boolean => {
    return store.hasAnyPermission(getTokenPermissionsForModule(module));
  };

  return {
    canView,
    canEdit,
    canAccess,
  };
}
